import { ThemeColors, ThemeShadows } from '../../../theme'

export type BaseLinkButtonVariant =
  | 'major'
  | 'minor'
  | 'caution'
  | 'onColor'
  | 'success'
  | 'warning'

export const baseLinkButtonVariantProps: Record<
  BaseLinkButtonVariant,
  {
    color: ThemeColors
    iconColor: ThemeColors
    underlineShadow: ThemeShadows
  }
> = {
  major: {
    color: 'fg/action',
    underlineShadow: 'border/link-underline-major',
    iconColor: 'fg/action',
  },
  minor: {
    color: 'fg/moderate',
    underlineShadow: 'border/link-underline-minor',
    iconColor: 'fg/moderate',
  },
  caution: {
    color: 'fg/caution',
    underlineShadow: 'border/link-underline-caution',
    iconColor: 'fg/caution',
  },
  onColor: {
    color: 'fg/major-on-color',
    underlineShadow: 'border/link-underline-minor',
    iconColor: 'fg/major-on-color',
  },
  success: {
    color: 'fg/success',
    underlineShadow: 'border/link-underline-minor',
    iconColor: 'fg/success',
  },
  warning: {
    color: 'fg/warning',
    underlineShadow: 'border/link-underline-minor',
    iconColor: 'fg/warning',
  },
}

export const baseLinkButtonProps = {
  display: 'block',
  m: 0,
  border: 'none',
  p: 0,
  // To keep consistent with button - https://html.spec.whatwg.org/multipage/rendering.html#button-layout
  // > If the computed value of 'inline-size' is 'auto', then the used value is the fit-content inline size
  w: 'fit-content',
  bg: 'transparent',
} as const
